import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Form, Formik, FormikErrors } from "formik";
import * as React from "react";
import ButtonGroup from "../../components/Buttons/ButtonGroup";
import ProgressIndicator from "../../components/ProgressIndicator";
import strings from "../../config/localization";
import {
  useNewOrganizationMutation,
  useGetOrganizationsQuery,
} from "../../services/appln";
import ErrorMsg from "../../components/ErrorMsg";
import Autocomplete from "@mui/material/Autocomplete";

interface FormData {
  name: string;
  parentId: string;
}

interface Props {
  onSubmitHandler: (newObj: any) => void;
  onCancelHandler: () => void;
  state: boolean;
}

export default function NewOrganization(props: Props) {
  const [createOrganization, createOrganizationParams] =
    useNewOrganizationMutation();

  const orgQueryResponse = useGetOrganizationsQuery("");
  const orgMap = new Map<string, string>();
  orgQueryResponse.data?.data.forEach((element: any) => {
    orgMap.set(element.name, element.id);
  });

  const iv: FormData = {
    name: "",
    parentId: "",
  };

  const onCancelHandlerWrapper = () => {
    createOrganizationParams.reset();
    props.onCancelHandler();
  };

  console.log(
    "NewOrganization, createOrganizationParams:",
    createOrganizationParams,
  );
  React.useEffect(() => {
    if (createOrganizationParams.isSuccess) {
      props.onSubmitHandler(createOrganizationParams.data.id);
    }
  }, [createOrganizationParams]);

  return (
    <div>
      <Dialog
        open={props.state}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {strings.newOrganization}
        </DialogTitle>
        {createOrganizationParams.isError && (
          <ErrorMsg msg={strings.failedToCreateOrganization} />
        )}
        {createOrganizationParams.isLoading && <ProgressIndicator />}
        <DialogContent>
          <Formik
            initialValues={iv}
            validate={(values) => {
              const errors: FormikErrors<FormData> = {};
              if (!values.name) {
                errors.name = strings.nameMandatory;
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(false);
              values.parentId = orgMap.get(values.parentId!)!;
              createOrganization(values);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        margin="normal"
                        id="name"
                        name="name"
                        label={strings.name}
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.name && Boolean(errors.name)}
                        helperText={touched.name && errors.name}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Autocomplete
                        fullWidth
                        disablePortal
                        id="parentId"
                        options={Array.from(orgMap.keys())}
                        renderInput={(params) => (
                          <TextField {...params} label={strings.parentOrg} />
                        )}
                        onChange={(e, value: any) => {
                          setFieldValue("parentId", value);
                        }}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <ButtonGroup>
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {strings.create}
                        </Button>
                        <Button
                          variant="contained"
                          onClick={onCancelHandlerWrapper}
                        >
                          {strings.cancel}
                        </Button>
                      </ButtonGroup>
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </div>
  );
}
